export default __webpack_public_path__ + "web-logo-bcc38d07633eabbd4b67f16d72610a1b.svg";